import React, { createContext, useState, useEffect } from 'react'
import withConfig from './withConfig'
// import toast from '../elem/Toast'
import Login from '../features/landing/Login'

const UserContext = createContext(null)

const UserContextProvider = ({ config, children }) => {
    const { API_URL } = config
    const [user, setUser] = useState(null)
    const [newObject, setNewObject] = useState(null)

    useEffect(() => {
        console.log(user)
    }, [user])

    return (
        <UserContext.Provider
            value={{
                user,
                setUser,
                setNewObject,
            }}
        >
            {user ? children : <Login />}
        </UserContext.Provider>
    )
}

export { UserContext }
export default withConfig(UserContextProvider)
